/**
 * 문제집별 통계 페이지
 * 특정 문제집의 문제별 정답률, 평균 시도 횟수 등 표시
 */

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Space, Button, Alert, Spin, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ProblemAccuracyTable } from '../../components/stats/ProblemAccuracyTable';
import { getWorkbookProblemStats } from '../../services/statsService';
import { WorkbookProblemStatsResponse } from '../../types/stats';

const { Title } = Typography;

export const WorkbookStatsPage: React.FC = () => {
  const { workbookName } = useParams<{ workbookName: string }>();
  const navigate = useNavigate();

  const [stats, setStats] = useState<WorkbookProblemStatsResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // 통계 데이터 로드
  const loadStats = async () => {
    if (!workbookName) {
      setError('문제집 이름이 없습니다.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await getWorkbookProblemStats(workbookName);
      setStats(data);
    } catch (err: any) {
      console.error('문제집 통계 로드 실패:', err);
      setError(err.response?.data?.detail || '통계를 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workbookName]);

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      {/* 헤더 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
            돌아가기
          </Button>
        </div>
        <Title level={3} style={{ margin: 0 }}>
          {workbookName} - 문제별 통계
        </Title>
      </div>

      {/* 에러 메시지 */}
      {error && <Alert message="에러" description={error} type="error" showIcon closable />}

      {/* 로딩 스피너 */}
      {loading && !stats ? (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
        </div>
      ) : (
        <>
          {/* 문제별 정답률 테이블 */}
          {stats && <ProblemAccuracyTable problems={stats.problems} loading={loading} />}
        </>
      )}
    </Space>
  );
};

export default WorkbookStatsPage;
